import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import { ifAuthenticated } from "../access";
import MNTemplates from "@/pages/Pages/MailNotify/MNTemplates.vue";
import MNTemplate from "@/pages/Pages/MailNotify/MNTemplate.vue";
import MNManagementTemplates from "@/pages/Pages/MailNotify/MNManagementTemplates.vue";
import MNManagementTemplate from "@/pages/Pages/MailNotify/MNManagementTemplate.vue";
import MNManagementServices from "@/pages/Pages/MailNotify/MNManagementServices.vue";
import MNManagementService from "@/pages/Pages/MailNotify/MNManagementService.vue";
import MNProviderTariffs from "@/pages/Pages/MailNotify/MNProviderTariffs.vue";
import MNProviderTariff from "@/pages/Pages/MailNotify/MNProviderTariff.vue";
import MNDetail from "@/pages/Pages/MailNotify/MNDetail.vue";
import MNDetailInfo from "@/pages/Pages/MailNotify/MNDetailInfo.vue";
import MNPartnerTariffs from "@/pages/Pages/MailNotify/MNPartnerTariffs.vue";
import MNPartnerTariff from "@/pages/Pages/MailNotify/MNPartnerTariff.vue";
import MNGroup from "@/pages/Pages/MailNotify/MNGroup.vue";
import {Route} from "vue-router";

const mailNotifyMenu = {
    path: "/mail_notify",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    redirect: "/mail_notify/management_services",
    name: "MailNotify",
    children: [
        {
            path: "templates",
            name: "mail_notify_templates",
            components: { default: MNTemplates },
            meta: {
                icon: "vk_icon",
                msgKey: 'menu.item.mail_notify.templates',
            },
        },
        {
            path: "templates/new",
            name: "mail_notify_templates_new",
            components: { default: MNTemplate },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/templates",
                msgKey: 'menu.item.mail_notify.templates',
            },
        },
        {
            path: "templates/:id",
            name: "mail_notify_templates_edit",
            components: { default: MNTemplate },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/templates",
                msgKey: 'menu.item.mail_notify.templates',
            },
        },
        {
            path: "partners/tariffs",
            name: "mail_notify_client_tariff",
            components: { default: MNPartnerTariffs },
            meta: {
                icon: "vk_icon",
                msgKey: 'menu.item.mail_notify.clients.tariff',
            }
        },
        {
            path: "partners/tariffs/new",
            name: "mail_notify_client_tariff_new",
            components: { default: MNPartnerTariff },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/partners/tariffs",
                msgKey: 'menu.item.mail_notify.clients.tariff',
            },
        },
        {
            path: "partners/tariffs/:id",
            name: "mail_notify_client_tariff_edit",
            components: { default: MNPartnerTariff },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/partners/tariffs",
                msgKey: 'menu.item.mail_notify.clients.tariff',
            }
        },
        {
            path: "management_templates",
            name: "mail_notify_management_templates",
            components: { default: MNManagementTemplates },
            meta: {
                icon: "vk_icon",
                msgKey: 'menu.item.mail_notify.external.templates',
            },
        },
        {
            path: "management_templates/new",
            name: "mail_notify_management_templates_new",
            components: { default: MNManagementTemplate },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/management_templates",
                msgKey: 'menu.item.mail_notify.external.templates',
            },
        },
        {
            path: "management_templates/:id",
            name: "mail_notify_management_templates_edit",
            components: { default: MNManagementTemplate },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/management_templates",
                msgKey: 'menu.item.mail_notify.external.templates',
            },
        },
        {
            path: "detail",
            name: "mail_notify_detail",
            components: { default: MNDetail },
            meta: {
                icon: "vk_icon",
                msgKey: 'menu.item.statistics.mail_notify.detail',
            },
        },
        {
            path: "detail/:id",
            name: "mail_notify_detail_info",
            components: { default: MNDetailInfo },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/detail",
                msgKey: 'menu.item.statistics.mail_notify.detail',
            },
        },
        {
            path: "group",
            name: "mail_notify_group",
            components: { default: MNGroup },
            meta: {
                icon: "vk_icon",
                msgKey: 'menu.item.statistics.mail_notify.group'
            },
        },
        {
            path: "service_providers/tariffs",
            name: "mail_notify_provider_tariff",
            components: { default: MNProviderTariffs },
            meta: {
                icon: "vk_icon",
                msgKey: 'menu.item.mail_notify.provider.tariff',
            },
        },
        {
            path: "service_providers/tariffs/new",
            name: "mail_notify_provider_tariff_new",
            components: { default: MNProviderTariff },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/service_providers/tariffs",
                msgKey: 'menu.item.mail_notify.provider.tariff',
            },
        },
        {
            path: "service_providers/tariffs/:id",
            name: "mail_notify_provider_tariff_edit",
            components: { default: MNProviderTariff },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/service_providers/tariffs",
                msgKey: 'menu.item.mail_notify.provider.tariff',
            },
        },
        {
            path: "management_services",
            name: "mail_notify_management_services",
            components: { default: MNManagementServices },
            meta: {
                icon: "vk_icon",
                msgKey: 'menu.item.mail_notify.external.services',
            },
        },
        {
            path: "management_services/new",
            name: "mail_notify_management_services_new",
            components: { default: MNManagementService },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/management_services",
                msgKey: 'menu.item.mail_notify.external.services',
            },
        },
        {
            path: "management_services/:id",
            name: "mail_notify_management_services_edit",
            components: { default: MNManagementService },
            meta: {
                icon: "vk_icon",
                parentPath: "/mail_notify/management_services",
                msgKey: 'menu.item.mail_notify.external.services',
            },
        },
    ],
};

// TODO Это надо будет убрать после приведение "mail notify" и "mail_notify" в единый формат
export const redirectMailNotify = {
    path: "/mail notify",
    redirect: "/mail_notify",
    beforeEnter(to: Route, from: Route, next: any){
        next({
            path: to.path.replace(' ','_'),
            replace: true
        })
    },
    children: [
        {path: "templates"},
        {path: "templates/new"},
        {path: "templates/:id"},
        {path: "partners/tariffs"},
        {path: "partners/tariffs/new"},
        {path: "partners/tariffs/:id"},
        {path: "service_providers/tariffs"},
        {path: "service_providers/tariffs/new"},
        {path: 'service_providers/tariffs/:id'}
    ]
}

export default mailNotifyMenu;
